import { render, staticRenderFns } from "./question-panel.vue?vue&type=template&id=4d8d65e4&scoped=true&"
import script from "./question-panel.vue?vue&type=script&lang=ts&"
export * from "./question-panel.vue?vue&type=script&lang=ts&"
import style0 from "./question-panel.vue?vue&type=style&index=0&id=4d8d65e4&lang=scss&scoped=true&"
import style1 from "./question-panel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8d65e4",
  null
  
)

export default component.exports